import { createContext } from 'react';
import { IntakeForm, Question } from '@qmd-types/intakeForms';

type ContextProps = {
  currentQuestion: Question | undefined;
  editQuestion: Question | null;
  handleEditQuestionResponse: (question: Question | null) => void;
  handleNextStep: () => void;
  intakeForm: IntakeForm;
  isIntakeFormComplete: boolean;
  setStep: (step: number) => void;
  showIntakeFormReview: boolean;
  step: number;
  updateAnswer: (questionId: string, updatedQuestion: Question) => void;
};

export const IntakeFormContext = createContext<ContextProps | undefined>(
  undefined,
);
